import React from 'react';
import { Table } from 'react-bootstrap';
import AtividadeRow from './AtividadeRow';

const EMPTY_ATIVIDADES = [];
const EMPTY_ACTIONS = {};

const AtividadesTable = React.memo(
  ({ atividades = EMPTY_ATIVIDADES, actions = EMPTY_ACTIONS }) => {
    return (
      <Table responsive="sm" striped bordered hover size="sm" variant="success">
        <thead className="m-0 p-0">
          <tr>
            <th>Procedimento</th>
            <th>Convênio</th>
            <th>Data</th>
            <th>Laudo</th>
            <th>Guia</th>
            <th>Valor</th>
            <th>Laudado</th>
            <th>Conv</th>
            <th>Fat</th>
            <th>Enc</th>
            <th>Rlz</th>
            <th>ID</th>
            <th>Func</th>
            <th>PDF</th>
            <th>#</th>
          </tr>
        </thead>
        <tbody className="m-0 p-0">
          {atividades.length === 0 ? (
            <tr>
              <td colSpan="15" className="text-center py-3 text-muted">
                Nenhum exame ou atividade encontrada para este paciente.
              </td>
            </tr>
          ) : (
            atividades.map((atividade, index) => (
              <AtividadeRow
                key={atividade.CODFATURA || atividade.CODLAUDO || index}
                atividade={atividade}
                actions={actions}
              />
            ))
          )}
        </tbody>
      </Table>
    );
  });

export default AtividadesTable;